import { Observable, takeWhile, tap, timer } from "rxjs";

import { IProductionPollGroupState } from "../../models";
import { isProductionPollStateTerminal } from "./production-polling.helpers";

interface ICreateProducePollingStreamArguments {
  intervalMs: number;
  /** When true, the first status check runs immediately (produce UX). */
  immediateFirstTick?: boolean;
  isRunning: () => boolean;
  onTick: (pollingCount: number) => void;
}

/**
 * Ticks while the produce group still has non-terminal productions. `isRunning` must be a callback so
 * each tick reads the latest Recoil state (same contract as bookings polling).
 */
export const createProducePollingStream = ({
  intervalMs,
  immediateFirstTick = true,
  isRunning,
  onTick,
}: ICreateProducePollingStreamArguments): Observable<number> => {
  const startDue = immediateFirstTick ? 0 : intervalMs;

  return timer(startDue, intervalMs).pipe(
    tap(pollingCount => onTick(pollingCount)),
    takeWhile(() => isRunning()),
  );
};

export const isProducePollingGroupRunning = (
  group: IProductionPollGroupState | undefined,
): boolean => {
  if (!group?.states?.length) {
    return false;
  }

  return group.states.some(state => !isProductionPollStateTerminal(state));
};

export const isProducePollingGroupNotRunning = (
  group: IProductionPollGroupState | undefined,
): boolean => {
  if (!group?.states?.length) {
    return true;
  }

  return !isProducePollingGroupRunning(group);
};
